import { pluralRu } from '@wit-support/ui';
import { accountTitle } from './campaign-name.js';
import { gapMinor, pct } from './format.js';
/**
 * Логика Сводки (спека §6.1) — чистые функции, без ИИ: фраза-вывод по
 * кабинетам, «Требуют внимания», кабинеты без расхода, дельты к прошлому
 * периоду.
 */
/** Кабинет с расходом или покупками за период (иначе он «без расхода»). */
export function hasActivity(a) {
    return a.spendMinorFull > 0 || a.purchases > 0;
}
/** Имя кабинета: из отчёта, иначе из справочника, иначе «Кабинет без названия». */
export function accountName(a, names) {
    return accountTitle(a.accountName ?? names.get(a.accountId) ?? null);
}
/**
 * Фраза по кабинетам в порядке расхода: «Soulmate (85 % расхода) ниже порога
 * даже в лучшем случае · GOOSE (15 % расхода) выше порога (предварительно)».
 * Кабинеты без вывода («мало покупок») и без расхода пропускаются.
 */
export function summaryPhrase(accounts, theta, names = new Map()) {
    return [...accounts]
        .filter((a) => hasActivity(a) && a.answer.verdict !== null)
        .sort((x, y) => y.spendMinorFull - x.spendMinorFull)
        .map((a) => {
        const lo = a.answer.interval?.lo ?? null;
        const hi = a.answer.interval?.hi ?? null;
        const where = hi !== null && hi < theta
            ? 'ниже порога даже в лучшем случае'
            : lo !== null && lo > theta
                ? 'выше порога'
                : 'около порога';
        const share = a.spendShare !== null ? ` (${pct(a.spendShare)} расхода)` : '';
        return `${accountName(a, names)}${share} ${where}${a.answer.preliminary ? ' (предварительно)' : ''}`;
    });
}
/** «5 кампаний требуют внимания ↓»; ни одной — `null`. */
export function attentionPhrase(n) {
    if (n <= 0)
        return null;
    const word = pluralRu(n, ['кампания', 'кампании', 'кампаний']);
    const verb = pluralRu(n, ['требует', 'требуют', 'требуют']);
    return `${n} ${word} ${verb} внимания ↓`;
}
/**
 * «Требуют внимания»: кампании с выводом, которые не окупаются даже в лучшем
 * случае (`interval.hi < θ`), — по «Не хватает / запас» от худшей, первые `limit`.
 */
export function attentionList(report, theta, limit = 5) {
    return report.campaigns
        .filter((c) => {
        const hi = c.answer.interval?.hi ?? null;
        return c.answer.verdict !== null && hi !== null && hi < theta;
    })
        .sort((a, b) => (gapMinor(a, theta) ?? 0) - (gapMinor(b, theta) ?? 0))
        .slice(0, limit);
}
/**
 * Выбранные кабинеты, у которых в периоде нет расхода (нет строки в отчёте
 * или строка нулевая), — их имена для «… — без расхода за период».
 */
export function absentAccounts(selected, breakdown, names) {
    const active = new Set(breakdown.filter(hasActivity).map((a) => a.accountId));
    const byId = new Map(breakdown.map((a) => [a.accountId, a]));
    return selected
        .filter((id) => !active.has(id))
        .map((id) => {
        const row = byId.get(id);
        return accountTitle(row?.accountName ?? names.get(id) ?? null);
    });
}
function rel(a, b) {
    return b > 0 ? (a - b) / b : null;
}
/** Дельты Сводки: R — текущий период, P — прошлый той же длины. */
export function deltas(R, P) {
    if (!P)
        return null;
    return {
        spend: rel(R.spendMinorFull, P.spendMinorFull),
        purchases: rel(R.purchases, P.purchases),
        cppDiffMinor: R.cpp !== null && P.cpp !== null ? R.cpp - P.cpp : null,
        prevSpendMinor: P.spendMinorFull,
        prevPurchases: P.purchases,
        prevCpp: P.cpp,
        prevRoas: P.answer.roas3,
    };
}
//# sourceMappingURL=summary-logic.js.map